// extracted by mini-css-extract-plugin
module.exports = {"crossButton":"UpgradeToPro_crossButton__2VHXB","closeButton":"UpgradeToPro_closeButton__3q5GP"};